
export default function About() {
  return (
    <section id="about" className="py-32 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="text-xs uppercase tracking-wider text-gray-500 mb-4 font-semibold">
              Who We Are
            </div>
            <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              <span className="text-gray-400 italic font-light">Experts in</span><br />
              iOS Development
            </h2>
          </div>
          
          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              JIM d.o.o. Mostar is a dedicated team of experts specializing in developing cutting-edge applications for the iOS platform. Our mission is to create innovative solutions that not only meet but exceed user expectations.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              With a focus on security, performance, and user experience, we craft applications that make a real difference in people's daily lives. Our flagship products, including VPN and Cleaner applications, are designed with meticulous attention to detail and built using the latest iOS technologies.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We believe in creating software that is not only functional but also intuitive and beautiful. Every line of code we write is aimed at delivering exceptional quality and reliability to our users worldwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}